export enum TicketEvent {
  MESSAGE_RECEIVED = 'ticket.message.received',
  TICKET_CREATED = 'ticket.created',
  TICKET_UPDATED = 'ticket.updated',
  TICKET_CLOSED = 'ticket.closed',
  TICKET_TRANSFERRED = 'ticket.transferred',
}
